import { Controller } from 'stimulus';
import 'lazysizes';
import 'lazysizes/plugins/native-loading/ls.native-loading';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

class LazyLoading extends Controller {
  //
}

LazyLoading.targets = [
  //
];

export default LazyLoading;
